if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      const productUrl = opener?.getAttribute('data-product-url');

      if (!productUrl) {
        super.show(opener);
        return;
      }

      const modalOpener = opener.closest('modal-opener, .quick-add');
      if (modalOpener) modalOpener.classList.add('quick-add--visible');
      opener.classList.add('btn--loading');
      opener.setAttribute('aria-disabled', 'true');
      opener.setAttribute('disabled', 'true');

      fetch(productUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Quick Shop request failed with status ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const quickBuyTemplate = responseHTML.getElementById('quick-buy-content');

          if (!quickBuyTemplate?.content) {
            throw new Error('Quick Shop template is missing from the product response');
          }

          const quickBuyContent = quickBuyTemplate.content.cloneNode(true);
          quickBuyContent.querySelectorAll('noscript').forEach((noScript) => noScript.remove());
          this.modalContent.replaceChildren(quickBuyContent);

          this.modalContent.querySelectorAll('img').forEach((image) => {
            if (image.complete) image.classList.add('loaded');
            image.addEventListener('load', () => image.classList.add('loaded'), { once: true });
          });

          if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          window.setTimeout(() => super.show(opener), 0);
        })
        .catch((error) => {
          console.error('Pythal Quick Shop could not open; loading the product page instead.', error);
          window.location.assign(productUrl);
        })
        .finally(() => {
          if (modalOpener) modalOpener.classList.remove('quick-add--visible');
          opener.removeAttribute('aria-disabled');
          opener.removeAttribute('disabled');
          opener.classList.remove('btn--loading');
        });
    }
  });
}
